import { useState, useEffect } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { portalApi, clearCustToken } from '../../api';
import Footer from '../../components/Footer';

const TABS = [
  { to: '/portal', label: '报货', icon: '🛒', end: true },
  { to: '/portal/buy', label: '购买', icon: '🛍️' },
  { to: '/portal/orders', label: '我的订单', icon: '📦' },
  { to: '/portal/inventory', label: '我的库存', icon: '📊' },
  { to: '/portal/statements', label: '对账', icon: '🧾' },
  { to: '/portal/notifications', label: '通知', icon: '🔔' },
];

export default function PortalLayout() {
  const [customer, setCustomer] = useState<any>(null);
  const nav = useNavigate();

  useEffect(() => {
    portalApi('/me').then((d: any) => setCustomer(d.customer)).catch(() => {});
  }, []);

  const logout = () => { clearCustToken(); nav('/portal/login'); };

  return (
    <div className="flex h-full bg-emerald-50/40">
      <div className="flex-1 flex flex-col">
        {/* 顶部栏 */}
        <header className="bg-emerald-700 text-white px-4 py-3 flex items-center justify-between sticky top-0 z-30">
          <div>
            <div className="font-bold">客户报货门户</div>
            <div className="text-xs opacity-80">{customer?.name || '—'}{customer?.code ? `（${customer.code}）` : ''}</div>
          </div>
          <button onClick={logout} className="text-sm bg-emerald-800 hover:bg-emerald-900 rounded-lg px-3 py-1.5">退出</button>
        </header>

        <main className="flex-1 overflow-auto px-4 py-4 pb-24 max-w-[900px] mx-auto w-full">
          <Outlet />
          <Footer />
        </main>

        {/* 底部 Tab */}
        <nav className="fixed bottom-0 inset-x-0 z-30 bg-white border-t border-slate-200 flex justify-around items-center h-16 shadow-[0_-2px_8px_rgba(0,0,0,0.06)]">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              end={t.end}
              className={({ isActive }) => `flex flex-col items-center justify-center flex-1 h-full text-xs ${isActive ? 'text-emerald-600 font-semibold' : 'text-slate-400'}`}
            >
              <span className="text-xl mb-0.5">{t.icon}</span>
              {t.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </div>
  );
}
